/* React */
import React from "react";

/* Ionic */
import { IonGrid, IonRow, IonCol } from "@ionic/react";

/* Simple Bar */
import SimpleBar from "simplebar-react";

/* Utils */
import { getTableLabel } from "src/utils/mapper/tableLabelMapper";

/* Stylesheet */
import styles from "./TableSlide.module.scss";
import "simplebar-react/dist/simplebar.min.css";

/* Interfaces */
import { DataType } from "src/shared/interfaces/charts/Table";
import { createGradient } from "src/utils/helper/charts/colorMapper";

interface TableSlideProps {
  data: DataType[];
  startIndex: number;
  endIndex: number;
  labelMapping?: Record<string, string>;
  color?: string;
}

const TableSlide: React.FC<TableSlideProps> = ({
  data,
  startIndex,
  endIndex,
  labelMapping,
  color,
}) => {
  const pageData: any[] = data.slice(startIndex, endIndex);
  const objKeys: string[] = Object.keys(data[0]);

  return (
    <SimpleBar
      style={{
        maxHeight: "364px",
        overflow: "auto",
        display: "block",
      }}
    >
      <IonGrid className={styles.table_slide}>
        {objKeys.map((key, rowIndex) => (
          <IonRow
            key={rowIndex}
            style={{
              color:
                rowIndex === 0
                  ? "#ffffff"
                  : "var(--ion-color-text-primary)",
              background:
                rowIndex === 0
                  ? color
                    ? createGradient(color)
                    : "var(--ion-gradient-secondary)"
                  : rowIndex % 2 === 0
                  ? "#ffffff"
                  : "var(--ion-gradient-light)",
            }}
            className={styles.row}
          >
            <IonCol
              className={`${styles.col} ${styles.label_col}`}
              size="3"
            >
              <div className={styles.label}>
                {getTableLabel(key, labelMapping)}
              </div>
            </IonCol>
            {pageData.map((items, colIndex) => (
              <IonCol
                key={colIndex}
                className={`${styles.col} ${styles.value_col}`}
              >
                <IonCol
                  className={styles.col}
                  sizeXs="4"
                  sizeXl={rowIndex === 0 ? "2" : "2"}
                >
                  <span>
                    {typeof items[key] === "string"
                      ? items[key].split(" (")[0]
                      : items[key]}
                  </span>
                </IonCol>
                <IonCol className={styles.col}>
                  <span className={styles.suffix}>
                    {typeof items[key] === "string"
                      ? items[key].match(/\(.*?\)/)?.[0] ??
                        ""
                      : ""}
                  </span>
                </IonCol>
              </IonCol>
            ))}
          </IonRow>
        ))}
      </IonGrid>
    </SimpleBar>
  );
};

export default TableSlide;
